export const VEHICLE_PHOTO_SIZE = 1280

export const AVATAR_PHOTO_SIZE = 480

const PHOTO_QUALITY = 0.78

const loadImage = (src: string): Promise<HTMLImageElement> => new Promise((resolve, reject) => {
    const image = new Image()

    image.onload = () => resolve(image)
    image.onerror = () => reject(new Error('This image could not be opened. Try a JPG or PNG photo.'))
    image.src = src
})

const drawToDataUrl = (source: CanvasImageSource, width: number, height: number, maxSize: number): string => {
    const scale = Math.min(1, maxSize / Math.max(width, height))
    const canvas = document.createElement('canvas')

    canvas.width = Math.max(1, Math.round(width * scale))
    canvas.height = Math.max(1, Math.round(height * scale))

    const context = canvas.getContext('2d')
    if (!context) throw new Error('Photos are not supported in this browser.')

    context.fillStyle = '#ffffff'
    context.fillRect(0, 0, canvas.width, canvas.height)
    context.drawImage(source, 0, 0, canvas.width, canvas.height)

    return canvas.toDataURL('image/jpeg', PHOTO_QUALITY)
}

export const fileToPhoto = async (file: File, maxSize = VEHICLE_PHOTO_SIZE): Promise<string> => {
    if (file.type && !file.type.startsWith('image/')) throw new Error('Choose a photo or image file.')

    const url = URL.createObjectURL(file)

    try {
        const image = await loadImage(url)
        return drawToDataUrl(image, image.naturalWidth, image.naturalHeight, maxSize)
    }
    finally {
        URL.revokeObjectURL(url)
    }
}

export const videoFrameToPhoto = (video: HTMLVideoElement, maxSize = VEHICLE_PHOTO_SIZE): string => {
    if (!video.videoWidth || !video.videoHeight) throw new Error('The camera is not ready yet. Try again in a second.')
    return drawToDataUrl(video, video.videoWidth, video.videoHeight, maxSize)
}
